import { Box, Container } from '@chakra-ui/react'
import React from 'react'

type Props = {
  children: React.ReactElement | React.ReactElement[]
}

export default function Frame({children}: Props) {

  return <Container maxW='container.lg' height="100%" maxH="600" borderWidth={2} borderRadius="lg" px={0} position="relative" overflow="hidden">
    {children}
  </Container>

}